import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a8ddc372&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ddc372",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8ddc372')) {
      api.createRecord('a8ddc372', component.options)
    } else {
      api.reload('a8ddc372', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a8ddc372&scoped=true&", function () {
      api.rerender('a8ddc372', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/user/user_buttons/index.vue"
export default component.exports